import CarouselCard from 'home/components/CarouselCard/CarouselCard'
import React from 'react'
import offerPageURL from 'lib/offerPageURL'
import CruisePriceDetails from './CruisePriceDetails'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import { getLocationString } from 'checkout/lib/utils/accommodation/location'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import { connect } from 'react-redux'
import useIsHomepage from 'home/hooks/isHomepage'
import CruiseDescription from './CruiseDescription'
import { toTitleCase } from '../utils'

interface Props {
  offer: App.CruiseOffer;
  onClick: () => void;
  isVelocityEnabled: boolean;
}

function CruiseOfferCard({ offer, onClick, isVelocityEnabled }: Props) {
  const isHomepage = useIsHomepage()
  const velocityFeatures = (isVelocityEnabled && !isHomepage) ? { canEarn: true, canBurn: true } : undefined

  return (
    <CarouselCard
      bookmarkButton={<BookmarkButton offer={offer} />}
      description={<CruiseDescription offer={offer}/>}
      image={offer.images[0]}
      location={getLocationString(offer)}
      title={toTitleCase(offer.name)}
      offerPriceDetails={<CruisePriceDetails offer={offer} />}
      offerUrl={offerPageURL(offer)}
      productType={offer.productType}
      velocityFeatures={velocityFeatures}
      onClick={onClick}
    />
  )
}

const mapStateToProps = (state: App.State): { isVelocityEnabled: boolean } => ({
  isVelocityEnabled: state.geo.partnership?.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE,
})

export default connect(mapStateToProps)(CruiseOfferCard)
